import { useState } from "react";

const milestones = [
  { day: 7, label: "萌新群众", icon: "ri-seedling-line" },
  { day: 30, label: "吃瓜熟手", icon: "ri-fire-line" },
  { day: 100, label: "蹲点达人", icon: "ri-flashlight-line" },
  { day: 365, label: "吃瓜元老", icon: "ri-award-line" },
];

export default function Community() {
  const [checked, setChecked] = useState(false);
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const honeypot = String(fd.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      return;
    }
    if (!email) {
      setStatus("error");
      setFormError("请先填写你的邮箱，才能订阅最新吃瓜动态。");
      return;
    }
    try {
      const res = await fetch("https://readdy.ai/api/form/daetmm3ep053ijub1heg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = (parsed as { code?: string } | null)?.code;
      const metaMsg =
        (parsed as { meta?: { message?: string; detail?: string } } | null)?.meta?.message ||
        (parsed as { message?: string } | null)?.message ||
        (parsed as { meta?: { detail?: string } } | null)?.meta?.detail ||
        responseText;
      if (res.ok && code === "OK" && !String(metaMsg).toLowerCase().includes("spam")) {
        setStatus("success");
        setEmail("");
        e.currentTarget.reset();
      } else {
        setStatus("error");
        setFormError(String(metaMsg) || "订阅失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络开小差了，请稍后再试一次。");
    }
  };

  return (
    <section id="community" className="relative overflow-hidden bg-background-50 py-14 md:py-20">
      <div className="absolute left-0 bottom-0 hidden h-72 w-72 translate-y-1/2 rounded-full bg-accent-100/70 blur-2xl lg:block"></div>
      <div className="relative mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="mb-2 text-xs font-medium tracking-widest text-accent-600">DAILY CHECK-IN</p>
            <h2 className="font-display text-3xl text-foreground-950 md:text-4xl">
              每日打卡，<span className="text-accent-600">蹲点成习惯</span>
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              每天花一分钟看看今天看什么、在线等瓜，打卡越久等级越高。坚持下来，
              你就是瓜田里最有排面的资深吃瓜人。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-2 text-xs text-foreground-600">
              <span className="font-medium text-foreground-900">连续打卡第 12 天</span>
              <button
                type="button"
                onClick={() => setChecked((v) => !v)}
                className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-medium text-background-50 transition-colors ${
                  checked ? "bg-accent-500" : "bg-primary-500 hover:bg-primary-600"
                }`}
              >
                <i className={checked ? "ri-check-double-line" : "ri-check-double-line"}></i>
                {checked ? "今日已打卡" : "今日吃瓜打卡"}
              </button>
            </div>

            <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {milestones.map((m) => (
                <div
                  key={m.day}
                  className="flex flex-col items-center gap-2 rounded-2xl border border-background-200 bg-background-100 px-3 py-4 text-center"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-50 text-lg text-accent-600">
                    <i className={m.icon}></i>
                  </span>
                  <div>
                    <p className="font-display text-base text-foreground-900">{m.day} 天</p>
                    <p className="mt-0.5 text-xs text-foreground-500">{m.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div id="subscribe" className="rounded-3xl bg-foreground-950 p-7 md:p-9">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-mail-send-line"></i>订阅吃瓜动态
            </span>
            <h3 className="mt-4 font-display text-2xl text-background-50">
              加入群众，第一时间吃到新鲜瓜
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-background-50/70">
              留下邮箱，最新热瓜、蹲后续进展和脉络整理会及时推送给你。我们承诺不发垃圾邮件，随时可退订。
            </p>

            <form onSubmit={handleSubmit} data-readdy-form className="mt-6 flex flex-col gap-3">
              <label htmlFor="email" className="sr-only">
                邮箱地址
              </label>
              <div className="flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/10 px-4">
                <i className="ri-mail-line text-background-50/60"></i>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="name@example.com"
                  autoComplete="off"
                  className="w-full bg-transparent py-3 text-sm text-background-50 outline-none placeholder:text-background-50/40"
                />
              </div>

              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hidden-subscribe-field"
              />

              <button
                type="submit"
                className="mt-1 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-line"></i>订阅吃瓜动态
              </button>
            </form>

            <div aria-live="polite" className="mt-4 min-h-5 text-sm">
              {status === "success" && (
                <p className="inline-flex items-center gap-2 text-accent-300">
                  <i className="ri-checkbox-circle-line"></i>订阅成功！最新吃瓜动态马上送到，蹲后续不错过。
                </p>
              )}
              {status === "error" && (
                <p className="inline-flex items-center gap-2 text-primary-300">
                  <i className="ri-error-warning-line"></i>
                  {formError}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}